import * as React from "react";

import { cn } from "@/utils/cn";

function Badge({ className, ...props }: React.ComponentProps<"span">) {
  return (
    <span
      data-slot="badge"
      className={cn("rounded-md bg-primary px-2 py-0.5 text-xs font-medium text-primary-foreground", className)}
      {...props}
    />
  );
}

export { Badge };
